<template>
    <section>
        <div class="left"><h2 v-translate>Kontaktní informace</h2></div>
        <div class="right">
            <div class="field_left">
                <text-input id="contactname" v-model="entity.contact.name" :disabled="!isEditable"><translate class="translate">Jméno kontaktní osoby</translate></text-input>
                <text-input id="contactemail" v-model="entity.contact.email" :disabled="!isEditable"><translate class="translate">E-mail kontaktní osoby</translate></text-input>
                <text-input id="contactphone" v-model="entity.contact.phone" :disabled="!isEditable"><translate class="translate">Telefon na kontaktní osobu</translate></text-input>
                <text-input id="contactcompanyname" v-model="entity.contact.company_name" :disabled="!isEditable"><translate class="translate">Název firmy</translate></text-input>
            </div>
            <div class="field_right">
                <text-input id="companyaddress" v-model="entity.contact.company_headquarters" :disabled="!isEditable"><translate class="translate">Sídlo firmy</translate></text-input>
                <text-input id="companyemail" v-model="entity.contact.company_email" :disabled="!isEditable"><translate class="translate">E-mail</translate></text-input>
                <text-input id="companywww" v-model="entity.contact.company_website" :disabled="!isEditable"><translate class="translate">WWW</translate></text-input>
                <text-input id="companycin" v-model="entity.contact.company_tin" :disabled="!isEditable"><translate class="translate">IČ</translate></text-input>
            </div>
        </div>
    </section>
</template>

<script>
	import TextInput from "@/components/common/TextInput"

	export default {
		name: "OperatorContact",
    components: {TextInput},
    props: {
			entity: Object,
      isEditable: Boolean,
    },
	}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/settings/OperatorContact.vue